export enum RewardCardType {
  GiftCard = 'giftCard',
  Charity = 'charity',
  Culture = 'culture',
}
